export const validateForm = (formState, isTeacher) => {
  let validationErrors = {
    emailErr: {},
    passwordErr: {},
    firstNameErr: {},
    lastNameErr: {},
    passwordConfirmationErr: {},
    abbreviationErr: {},
    schoolsErr: "", // ✅ NEW
  };

  let isValid = true;

  // ✅ EMAIL
  if (formState.email === "") {
    validationErrors.emailErr.userNameEmpty = "E-Mail eingeben!";
    isValid = false;
  } else if (!formState.email.includes("@sluz.ch")) {
    validationErrors.emailErr.username =
      "E-mail muss eine SLUZ-Mailadresse sein";
    isValid = false;
  } else if (formState.email.length >= 40) {
    validationErrors.emailErr.userNameTooLong = "E-Mail zu lange!";
    isValid = false;
  }

  // ✅ PASSWORD
  if (formState.password === "") {
    validationErrors.passwordErr.userPasswordEmpty = "Passwort eingeben!";
    isValid = false;
  } else if (formState.password.length < 7) {
    validationErrors.passwordErr.userPasswordTooShort =
      "Passwort min. 7 Zeichen!";
    isValid = false;
  }

  // ✅ PASSWORD CONFIRM
  if (formState.password !== formState.passwordConfirmation) {
    validationErrors.passwordConfirmationErr.userPasswordNotConfirmed =
      "Passwörter nicht identisch!";
    isValid = false;
  }

  // ✅ FIRST NAME
  if (formState.firstName === "") {
    validationErrors.firstNameErr.firstNameEmpty = "Vornamen eingeben!";
    isValid = false;
  } else if (formState.firstName.length >= 30) {
    validationErrors.firstNameErr.firstNameTooLong = "Vorname zu lange!";
    isValid = false;
  }

  // ✅ LAST NAME
  if (formState.lastName === "") {
    validationErrors.lastNameErr.lastNameEmpty = "Nachnamen eingeben!";
    isValid = false;
  } else if (formState.lastName.length >= 30) {
    validationErrors.lastNameErr.lastNameTooLong = "Nachname zu lange!";
    isValid = false;
  }

  // ✅ TEACHER ABBREVIATION
  if (isTeacher) {
    if (!formState.abbreviation || formState.abbreviation.length < 2) {
      validationErrors.abbreviationErr.abbr = "Kürzel erforderlich!";
      isValid = false;
    }
  }

  // ✅ ✅ SCHOOLS (NEW ✅✅)
  if (!formState.schools || formState.schools.length === 0) {
    validationErrors.schoolsErr = "Bitte mindestens eine Schule wählen!";
    isValid = false;
  }

  return { isValid, validationErrors };
};
